import * as React from 'react';

// @ts-expect-error
import capitalize from 'underscore.string/capitalize';

import type {DeviceType} from '../../../types';

import {DesktopIcon} from '../../../../icon/svg/desktop-icon';
import {MobilePhoneRegularIcon} from '../../../../icon/svg/mobile-phone-regular-icon';
import {TabletIcon} from '../../../../icon/svg/tablet-icon';
import {Divider} from '../../../../layout/divider';
import {StackLegacy} from '../../../../layout/stack/stack-legacy';

import styles from './session-metadata.module.css';

type Props = {
    locationSummary: string | null | undefined;
    deviceType: DeviceType;
    platformType: string | null | undefined;
};

export function SessionMetadata(props: Props) {
    const {locationSummary, deviceType} = props;
    const platformType = props.platformType === 'Unknown' ? undefined : props.platformType;

    let Icon: React.ComponentType<any> | null | undefined = null;
    // This is only used for the icon
    switch (deviceType) {
        case 'desktop':
            Icon = DesktopIcon;
            break;
        case 'tablet':
            Icon = TabletIcon;
            break;
        case 'mobile':
            Icon = MobilePhoneRegularIcon;
            break;
    }

    const capitalizeLocationSummary = (location: string): string => {
        // Turns 'ann arbor, MI' to 'Ann Arbor, MI'
        return location
            .split(' ')
            .map((word) => capitalize(word))
            .join(' ');
    };

    return platformType || locationSummary ? (
        <div className={styles['session-metadata']}>
            {platformType ? (
                <StackLegacy spacing={8} isHorizontal={true}>
                    <div>{Icon ? <Icon size={15} /> : undefined}</div>
                    {platformType}
                </StackLegacy>
            ) : undefined}
            {platformType && locationSummary ? <Divider variant='dot' spacing={6} /> : undefined}
            {locationSummary ? <div>{capitalizeLocationSummary(locationSummary)}</div> : undefined}
        </div>
    ) : null;
}
